import {Access} from "../Constants/userRoles";

/**
 * @deprecated
 */
export function hasAccess(user, role, access = Access.Admin) {
    return user && user.userRoles.some(r => r.roleId === role && r.access >= access);
}

/**
 * @deprecated
 */
export function hasAdminAccess(user, role) {
    return hasAccess(user, role, Access.Admin);
}

/**
 * @deprecated
 */
export function hasReadWriteAccess(user, role) {
    return hasAccess(user, role, Access.ReadWrite);
}